'use client'

import {useEffect} from "react";
import {TeamTab} from "@/utils/teamTabs";

interface TabContainerProbs {
  teamTab: TeamTab
}
export function TeamTabContainer({teamTab}:TabContainerProbs){
  useEffect(() => {
    const adjustIframeHeight = () => {
      const otherElementsHeight = 290; // Height of other page elements in pixels
      const availableHeight = window.innerHeight - otherElementsHeight;
      const iframe = document.getElementById('tabIFrame');
      if (iframe) {
        iframe.style.height = `${availableHeight}px`;
      }
    };
    // Adjust height on load
    adjustIframeHeight();
    // Adjust height on window resize
    window.addEventListener('resize', adjustIframeHeight);
    // Cleanup
    return () => window.removeEventListener('resize', adjustIframeHeight);
  }, []);

  return (
    <iframe
      id="tabIFrame"
      src={teamTab.pageUrl}
      name={`tab_iframe_${teamTab.title}_${teamTab._id}`}
      style={{ width: '100%' }}
      title={`Tab: ${teamTab.title}`}
    />)
}
